// extracted by mini-css-extract-plugin
export default {"notfound":"NotFound_notfound__ZH-n4","notfound_wrap":"NotFound_notfound_wrap__SS3c6"};